module.exports = __webpack_public_path__ + "static/media/play.2eeb981d.svg";